export var AttributeType;
(function (AttributeType) {
    AttributeType["RADIO"] = "radio";
    AttributeType["COLOR"] = "color";
    AttributeType["CHECKBOX"] = "checkbox";
    AttributeType["SELECT"] = "select";
    AttributeType["IMAGE"] = "image";
})(AttributeType || (AttributeType = {}));
